import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';

import {
  FormControlLabel,
  FormLabel,
  Link,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { FieldValidation } from '@rjsf/utils';

export const VPCAttachmentExtensionSchema: CustomFieldExtensionSchema = {
  returnValue: { type: 'string' },
};

export const VPCAttachment = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => {
  // Set up variables for accounts-api validation call

  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
    >
      <FormLabel id="managed-vpc-radio-buttons-group">
        Is a Foundation Managed VPC required for the account(s) in your
        workload? (Note: You can no longer create your own VPC. If your workload
        requires a VPC, select yes)
      </FormLabel>
      <RadioGroup
        aria-labelledby="managed-vpc-radio-buttons-group"
        name="managed-vpc-radio-buttons-group"
        value={formData}
        onChange={e => onChange(e.target?.value)}
        row
      >
        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
      </RadioGroup>
      <FormHelperText id="managedVPCHelperText">
        <Typography variant="body1">
          Choose yes to enable a{' '}
          <Link
            target="_blank"
            href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/infrastructure/aws/foundation-managed-vpc"
          >
            Foundation Managed VPC
          </Link>{' '}
          in your account(s).
        </Typography>
      </FormHelperText>
    </FormControl>
  );
};

export const PublicSubnetExtensionSchema: CustomFieldExtensionSchema = {
  returnValue: { type: 'string' },
};

export const PublicSubnet = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => {
  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
    >
      <FormLabel id="public-subnet-radio-buttons-group">
        Is a public subnet required in the Foundation Managed VPC?
      </FormLabel>
      <RadioGroup
        aria-labelledby="public-subnet-radio-buttons-group"
        name="public-subnet-radio-buttons-group"
        value={formData}
        onChange={e => onChange(e.target?.value)}
        row
      >
        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
      </RadioGroup>
      <FormHelperText id="publicSubnetHelperText">
        <Typography variant="body1">
          Choose yes to enable a{' '}
          <Link
            target="_blank"
            href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/implementation/building/network/aws/foundation-managed-vpc/#subnet-tagging"
          >
            public subnet
          </Link>{' '}
          in your Foundation Managed VPC.
        </Typography>
      </FormHelperText>
    </FormControl>
  );
};

export const validatePublicSubnet = (
  value: string,
  validation: FieldValidation,
  { formData }: any,
) => {
  if (formData.foundationVPC === 'No' && value === 'Yes') {
    validation.addError(
      'You must request a foundation managed VPC in order to request a public subnet!',
    );
  }
};
